import type React from "react";
import { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
	List,
	ListItem,
	ListItemText,
	CircularProgress,
} from "@mui/material";
import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { addLinkAssetPart } from "@/pages/asset-details/repositories/AssetDetailsRepositorie";
import { ErrorModal } from "@dexteel/mesf-core";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
	AssetId: number | string;
	searchAssetResources?: Function;
	TemplateName: string;
	AssetName: string;
};

export const AssetAddPartsDialog: React.FC<Props> = ({
	show,
	onHide,
	AssetId,
	searchAssetResources,
	TemplateName,
	AssetName,
}) => {
	const {
		state: { templatePartsToAdd },
	} = useTemplatesContext();

	const [isAdding, setIsAdding] = useState(false);
	const [error, setError] = useState("");

	const addResourcesToAsset = async () => {
		setIsAdding(true);
		const allSuccessful = true;

		for (const part of templatePartsToAdd) {
			const res = await addLinkAssetPart(AssetId, part.PartName, "");
			if (res.ok) {
				setIsAdding(false);
				onHide(allSuccessful);
				if (searchAssetResources) searchAssetResources();
			} else {
				setError(res.message);
			}
		}
	};

	return (
		<Dialog
			open={show}
			onClose={() => onHide(false)}
			aria-labelledby="responsive-dialog-title"
		>
			<DialogTitle style={{ paddingBottom: 6 }} id="responsive-dialog-title">
				{templatePartsToAdd?.length > 1
					? `Add parts to Asset: ${AssetName}`
					: `Add part to Asset: ${AssetName}`}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					The following parts have been added to the Template {TemplateName}.
					Would you like to add them to the corresponding asset as well?
				</DialogContentText>
				<List>
					{templatePartsToAdd.map((part: any, index: any) => (
						<ListItem key={index}>
							<ListItemText
								primary={part.PartName + " - " + part.Description}
							/>
						</ListItem>
					))}
				</List>
			</DialogContent>
			<DialogActions style={{ padding: "24px" }}>
				<Button
					variant="contained"
					fullWidth
					color="inherit"
					onClick={() => onHide(false)}
					disabled={isAdding}
				>
					SKIP
				</Button>
				<Button
					fullWidth
					variant="contained"
					onClick={addResourcesToAsset}
					color="primary"
					autoFocus
					disabled={isAdding}
				>
					{isAdding ? <CircularProgress size={24} /> : "ADD"}
				</Button>
			</DialogActions>
			<ErrorModal error={error} onHide={() => setError("")} />
		</Dialog>
	);
};
